<template>
    <b-modal
        :id="`modal-order-scoring_${modalKey}`"
        :ref="`scoringModal_${modalKey}`"
        :title="`Оценка Поставки #${openScoreBoxItemId}`"
        @shown="onShowModal"
        @hidden="onCloseModal"
        hide-footer
        size="lg"
    >
        <div class="position-relative pt-2 pb-4">
            <template v-if="!readyForClose">
                <p class="font-italic">Оцените исполнение поставки по следующим критериям.</p>
                <div class="row mt-3 mb-3">
                    <div class="col-md-6">
                        <p class="font-weight-bold">Скорость исполнения поставки</p>
                        <b-form-checkbox
                            id="checkboxOrderSpeedScoreId3"
                            name="checkboxOrderSpeedScoreId3"
                            v-model="motivations[3]"
                            :value="true"
                            :unchecked-value="false"
                        >
                            <p class="mb-0">1. С момента закрытия доставки<br>
                                на терминале до выпуска ДТ</p>
                            <p class="text-center"><span class="numberInScores">≤12 часов</span></p>
                        </b-form-checkbox>

                        <b-form-checkbox
                                id="checkboxOrderSpeedScoreId4"
                                name="checkboxOrderSpeedScoreId4"
                                v-model="motivations[4]"
                                :value="true"
                                :unchecked-value="false"
                            >
                            <p class="mb-0">2. С момента закрытия доставки<br>
                                на терминале до убытия груза</p>
                            <p class="text-center"><span class="numberInScores">≤24 часов</span><br>
                            авто, авиа<br>
                                <span class="numberInScores">≤48 часов</span><br>
                                ж/д, море</p>
                        </b-form-checkbox>
                    </div>
                    <div class="col-md-6">
                        <p class="font-weight-bold">Одобрение клиентом поставки</p>
                        <b-form-group label="" v-slot="{ ariaDescribedby }">
                            <b-form-radio v-model="selectedScoreOfGratitude" name="orderScoringRadioGratitude" value="">Пока не получено</b-form-radio>
                            <b-form-radio class="mt-3" v-model="selectedScoreOfGratitude" name="orderScoringRadioGratitude" value="5">Получение благодарности/<br>
                                рекомендации от клиента<br>
                                на официальном бланке<br>
                                (приложите файл к Поставке в разделе Документы)
                            </b-form-radio>
                            <b-form-radio class="mt-3" v-model="selectedScoreOfGratitude" name="orderScoringRadioGratitude" value="6">Получение положительной<br>
                                оценки работы по эл. почте<br>
                                (приложите скриншот к Поставке в разделе Документы)
                            </b-form-radio>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <b-button size="lg"
                                  variant="success"
                                  @click="saveScoringResults()"
                        >
                            Завершить оценку
                        </b-button>
                    </div>
                </div>
            </template>
            <template v-if="readyForClose">
                <h1 class="text-center my-5">Спасибо за вашу оценку!</h1>
                <div class="row">
                    <div class="col-sm-12 text-center">
                        <b-button size="lg"
                                  variant="success"
                                  @click="closeModalNow()"
                        >
                            Закрыть
                        </b-button>
                    </div>
                </div>
            </template>
            <b-overlay
                :show="modalOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </div>
    </b-modal>
</template>

<script>
    import {
        API_POST_MOTIVATION_ORDER_SCORING,
        API_GET_MOTIVATION_ORDER_SCORING
    } from '../../constants'

    export default {
        props: {
            openScoreBoxIndex: { type: Number, required: true },                            // Index of updating item
            openScoreBoxItemId: { type: Number, required: true },                           // ID of updating item
            modalKey: { type: String, required: false, default: '' },                       // You need key, if you have more then one same modals
        },
        data() {
            return {
                isOpenOrderScoringModal: false,
                modalOverlay: true,
                motivations: {
                    3: false,   // speed 1
                    4: false,   // speed 2
                    5: false,   // graditude on company blank
                    6: false,   // graditude from email
                },
                selectedScoreOfGratitude: '',
                readyForClose: false
            }
        },
        watch: {
            openScoreBoxIndex: {
                immediate: true,
                handler(value) {
                    if (value != -1) {
                        this.isOpenOrderScoringModal = true
                        this.loadOrderMotivationScores()
                    }
                }
            },
            isOpenOrderScoringModal: {
                immediate: false,
                handler(value) {
                    if (value) {
                        this.$bvModal.show(`modal-order-scoring_${this.modalKey}`)
                    } else {
                        this.$bvModal.hide(`modal-order-scoring_${this.modalKey}`)
                    }
                }
            },
            selectedScoreOfGratitude: {
                immediate: false,
                handler(value) {
                    this.motivations[5] = false
                    this.motivations[6] = false

                    if (value) {
                        this.motivations[value] = true
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            onShowModal() {
                this.modalOverlay = false
            },
            closeModalNow() {
                this.$bvModal.hide(`modal-order-scoring_${this.modalKey}`)
            },
            onCloseModal() {
                this.modalOverlay = true
                this.isOpenOrderScoringModal = !this.isOpenOrderScoringModal
                this.readyForClose = false
                this.selectedScoreOfGratitude = ''
                this.motivations[3] = false
                this.motivations[4] = false
                this.motivations[5] = false
                this.motivations[6] = false
                this.$emit('scoringItemClose')
            },
            loadOrderMotivationScores: async function() {
                this.modalOverlay = true

                const response = await api.call('get', API_GET_MOTIVATION_ORDER_SCORING + `/${this.openScoreBoxItemId}`)

                let motivationList = response.data

                motivationList.forEach((motivation, index) => {
                    if (this.motivations.hasOwnProperty(motivation.motivation_setting_id)) {
                        if (motivation.sum != 0) {
                            this.motivations[motivation.motivation_setting_id] = true

                            if (motivation.motivation_setting_id == 5 || motivation.motivation_setting_id == 6) {
                                this.selectedScoreOfGratitude = motivation.motivation_setting_id
                            }
                        }
                    }
                })

                this.modalOverlay = false
            },
            saveScoringResults() {
                this.modalOverlay = true

                const params = {
                    motivations: this.motivations,
                    order_id: this.openScoreBoxItemId
                }

                api.call("post", `${API_POST_MOTIVATION_ORDER_SCORING}`, params).then(({data}) => {
                    this.readyForClose = true
                    this.modalOverlay = false
                })
            },
        }
    }
</script>
<style>
    .numberInScores {
        font-size: 28px;
        color: #0d6247;
    }
</style>
